"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NumberConverter = require("./NumberConverter");

var _NumberConverter2 = _interopRequireDefault(_NumberConverter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FileSizeConverter = function () {
  function FileSizeConverter() {
    _classCallCheck(this, FileSizeConverter);
  }

  _createClass(FileSizeConverter, null, [{
    key: "Convert",
    value: function Convert(value) {
      //value:Wert als Int
      var y = value;
      var sizes = ["KB", "MB", "GB", "TB"];
      var finished = false;
      var x = '';
      var i = 0;
      var languageFormat = localStorage.getItem("vas_language");

      if (y < 1024) {
        x = value + 'B';
        return x;
      } else {
        while (finished === false) {
          y = y / 1024;
          if (y >= 1024) {
            i++;
          } else {
            finished = true;
          }
        }
        x = _NumberConverter2.default.Cast(y, languageFormat, 1) + ' ' + sizes[i];
        return x;
      }
    }
  }]);

  return FileSizeConverter;
}();

exports.default = FileSizeConverter;